/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */

export type TracksControllerListClassificationsTypesItem =
  (typeof TracksControllerListClassificationsTypesItem)[keyof typeof TracksControllerListClassificationsTypesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TracksControllerListClassificationsTypesItem = {
  MOOD: "MOOD",
  GENRE: "GENRE",
  SUBGENRE: "SUBGENRE",
  SOUNDKIT_TYPE: "SOUNDKIT_TYPE",
} as const;
